import actions from './action';
import { DataService } from '../../config/dataService/dataService';

const {
  // dashboard
  dashboardBegin,
  dashboardSuccess,
  dashboardErr,

  // pivot
  pivotBegin,
  pivotSuccess,
  pivotErr,

  // profit
  profitBegin,
  profitSuccess,
  profitErr,

  profitabilityBegin,
  profitabilitySuccess,
  profitabilityErr,

  profitmodalBegin,
  profitmodalSuccess,
  profitmodalErr,

  estimatedFeesBegin,
  estimatedFeesSuccess,
  estimatedFeesErr,

  notificationBegin,
  notificationSuccess,
  notificationErr,

  supportTicketsBegin,
  supportTicketsSuccess,
  supportTicketsErr,

  getsupportTicketsBegin,
  getsupportTicketsSuccess,
  getsupportTicketsErr,

  getTicketsDetailsBegin,
  getTicketsDetailsSuccess,
  getTicketsDetailsErr,

  profitSKUIdBegin,
  profitSKUIdSuccess,
  profitSKUIdErr,

  actionRequiredBegin,
  actionRequiredSuccess,
  actionRequiredErr,
} = actions;

const mockService = async (payload) => {
  console.log('EXPORT PAYLOAD =>', payload);

  return new Promise((resolve) => {
    setTimeout(() => {
      const blob = new Blob(['Dummy excel content'], {
        type: 'application/vnd.ms-excel',
      });

      resolve({
        data: blob,
      });
    }, 500);
  });
};

export const getDashboard = (payload) => {
  return async (dispatch) => {
    dispatch(dashboardBegin());

    try {
      const response = await DataService.post('/amazon/dashboard-stats/', payload);

      if (response.data?.status === 'success' || response.data?.status === true) {
        dispatch(dashboardSuccess(response.data));
      } else {
        dispatch(dashboardErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(dashboardErr(err));
    }
  };
};
export const getPivotStats = (payload) => {
  return async (dispatch) => {
    dispatch(pivotBegin());

    try {
      const response = await DataService.post('/amazon/pivot-stats/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(pivotSuccess(response.data));
      } else {
        dispatch(pivotErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(pivotErr(err));
    }
  };
};

export const getProfitData = (payload) => {
  return async (dispatch) => {
    dispatch(profitBegin());

    try {
      const response = await DataService.post('/amazon/dashboard-profitability/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitSuccess(response.data));
      } else {
        dispatch(profitErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitErr(err));
    }
  };
};

const { monthwiseProfitBegin, monthwiseProfitSuccess, monthwiseProfitErr } = actions;

export const getProfitMonthwise = (payload) => {
  return async (dispatch) => {
    dispatch(monthwiseProfitBegin());

    try {
      const response = await DataService.post('/amazon/profitability-monthwise/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(monthwiseProfitSuccess(response.data));
      } else {
        dispatch(monthwiseProfitErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(monthwiseProfitErr(err));
    }
  };
};

export const getProfitDetails = (payload) => {
  return async (dispatch) => {
    dispatch(profitBegin());

    try {
      const response = await DataService.post('/amazon/profitability/details/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitSuccess(response.data)); // same reducer use kar sakte ho
      } else {
        dispatch(profitErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitErr(err));
    }
  };
};

export const getPaymentReconcileDetails = (payload) => {
  return async (dispatch) => {
    dispatch(profitBegin());

    try {
      const response = await DataService.post('/amazon/payment-reconcile/details/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitSuccess(response.data));
      } else {
        dispatch(profitErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitErr(err));
    }
  };
};

export const getPaymentReconcileDetailsByParentAsin = (payload) => {
  return async (dispatch) => {
    dispatch(profitabilityBegin());

    try {
      const response = await DataService.post('/amazon/payment-reconcile/details/by-parent-asin/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitabilitySuccess(response.data));
      } else {
        dispatch(profitabilityErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitabilityErr(err));
    }
  };
};

export const getProfitDetailsByParentId = (payload) => {
  return async (dispatch) => {
    dispatch(profitBegin());
    try {
      const response = await DataService.post('/amazon/profitability/details/by-parentproductid/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitSuccess(response.data)); // same reducer reuse
      } else {
        dispatch(profitErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitErr(err));
    }
  };
};

export const getPaymentReconcileDetailsByParentProductId = (payload) => {
  return async (dispatch) => {
    dispatch(profitabilityBegin());
    try {
      const response = await DataService.post('/amazon/payment-reconcile/details/by-parentproductid/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitabilitySuccess(response.data));
      } else {
        dispatch(profitabilityErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitabilityErr(err));
    }
  };
};

export const exportProfitData = (payload) => {
  return async () => {
    try {
      // const response = await DataService.post('/amazon/export', payload, {
      //   responseType: 'blob',
      // });
      const response = await mockService(payload);

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');

      link.href = url;

      link.setAttribute('download', 'profit.xlsx');

      document.body.appendChild(link);

      // link.click();

      link.remove();
    } catch (error) {
      console.log(error);
    }
  };
};

export const exportProfitabilityDetails = (
  payload,
  format = 'xlsx',
  endpoint = '/amazon/profitability/details/export/',
) => {
  return async () => {
    try {
      const response = await DataService.post(`${endpoint}?file_format=${format}`, payload, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const contentDisposition = response.headers['content-disposition'];
      let filename = `profitability_details.${format}`;
      if (contentDisposition) {
        // const match = contentDisposition.match(/filename="?([^"]+)"?/);
        // if (match && match[1]) {
        //   filename = match[1];
        // }
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        const [, matchedFilename] = match || [];

        if (matchedFilename) {
          filename = matchedFilename;
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
    }
  };
};

export const getSecondDetials = (payload) => {
  return async (dispatch) => {
    dispatch(profitabilityBegin());

    try {
      const response = await DataService.post('/amazon/profitability/details/by-parent-asin/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitabilitySuccess(response.data));
      } else {
        dispatch(profitabilityErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitabilityErr(err));
    }
  };
};

export const getProfitModalApi = (payload) => {
  return async (dispatch) => {
    dispatch(profitmodalBegin());

    try {
      const response = await mockService(payload);

      if (response.data?.status === 'success' || response.data?.status === true) {
        dispatch(profitmodalSuccess(response.data));
      } else {
        dispatch(profitmodalErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitmodalErr(err.message));
    }
  };
};

export const getEstimatedFees = (payload) => {
  return async (dispatch) => {
    dispatch(estimatedFeesBegin());

    try {
      const response = await DataService.post('/amazon/estimated-fees/list/', payload);
      console.log('API Response =>', response);
      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(estimatedFeesSuccess(response.data));
      } else {
        dispatch(estimatedFeesErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(estimatedFeesErr(err));
    }
  };
};

export const getNotifications = () => {
  return async (dispatch) => {
    dispatch(notificationBegin());

    try {
      const response = await DataService.get('/user/user-notifications/');
      console.log('API Response =>', response);
      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(notificationSuccess(response.data));
      } else {
        dispatch(notificationErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(notificationErr(err));
    }
  };
};

export const createSupportTickets = (payload) => {
  return async (dispatch) => {
    dispatch(supportTicketsBegin());

    try {
      const response = await DataService.post('/user/user-tickets/create/', payload);
      console.log('API Response =>', response);
      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(supportTicketsSuccess(response.data));
        return response.data;
      }
      throw new Error('Something went wrong');
    } catch (err) {
      dispatch(supportTicketsErr(err));
      throw err; // <-- Important
    }
  };
};

export const getSupportTickets = () => {
  return async (dispatch) => {
    dispatch(getsupportTicketsBegin());

    try {
      const response = await DataService.get('/user/user-tickets/list/');

      if (response.data?.results?.status === true) {
        dispatch(getsupportTicketsSuccess(response.data.results));
      } else {
        dispatch(getsupportTicketsErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(getsupportTicketsErr(err));
    }
  };
};

export const getSupportTicketsDetails = (id, callback) => {
  return async (dispatch) => {
    dispatch(getTicketsDetailsBegin());

    try {
      const response = await DataService.get(`/user/user-tickets/${id}/`);

      if (response.data?.status === true) {
        dispatch(getTicketsDetailsSuccess(response.data.data));

        if (callback) callback();
      } else {
        dispatch(getTicketsDetailsErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(getTicketsDetailsErr(err));
    }
  };
};

export const getProfitSKUId = (payload) => {
  return async (dispatch) => {
    dispatch(profitSKUIdBegin());

    try {
      const response = await DataService.post('/amazon/profitability/list/by-sku/filtered/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(profitSKUIdSuccess(response.data));
      } else {
        dispatch(profitSKUIdErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(profitSKUIdErr(err));
    }
  };
};

export const getActionRequired = (payload) => {
  return async (dispatch) => {
    dispatch(actionRequiredBegin());

    try {
      const response = await DataService.post('/amazon/growth-opportunities/', payload);

      if (response.data?.status === true || response.data?.status === 'success') {
        dispatch(actionRequiredSuccess(response.data));
      } else {
        dispatch(actionRequiredErr('Something went wrong'));
      }
    } catch (err) {
      dispatch(actionRequiredErr(err));
    }
  };
};
